import { render } from "./CardPayments.vue?vue&type=template&id=02ae7efa&scoped=true"
import script from "./CardPayments.vue?vue&type=script&lang=js"
export * from "./CardPayments.vue?vue&type=script&lang=js"

import "./CardPayments.vue?vue&type=style&index=0&id=02ae7efa&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ae7efa"]])

export default __exports__